import axios from 'axios'
import { Message } from 'element-ui'
// import store from '@/store'
// import { getToken } from '@/utils/auth'
// import { resetRouter } from '@/router'
import tools from '@/utils/tools'

const http = {}
const service = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 60000 
})

// request interceptor
service.interceptors.request.use(
  config => {
    // if (store.getters.token) {
    //   config.headers['Authorization'] = 'Bearer ' + getToken()
    // }
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem("sessionToken");
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求出错，服务器拒绝响应'
          break
        case 401:
          var msg = '授权失败，请重新登录'
          if (!tools.isEmpty(error.response.data)) {
            if (!tools.isEmpty(error.response.data.message)) {
              msg = error.response.data.message
            }
          }
          Message.warning({
            message: msg
          })
          localStorage.clear();
          sessionStorage.clear();
          setTimeout(() => {
            resetRouter()
            location.reload()
          }, 2000)
          // store.dispatch('user/resetToken').then(() => {
          //   setTimeout(() => {
          //     resetRouter()
          //     location.reload()
          //   }, 2000)
          // })
          return
        case 403:
          error.message = '拒绝访问，您无权操作！'
          break
        case 404:
          error.message = '请求错误，未找到该资源'
          break
        case 500:
          error.message = '服务器端出错'
          break
      }
    } else {
      error.message = '连接服务器失败'
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

http.get = (params) => {
  return new Promise((resolve, reject) => {
    const { url, options, handler, permissionKey } = params
    // var headersPermission = null
    // if (permissionKey != null) {
    //   headersPermission = { headers: { 'PermissionKey': permissionKey } }
    // }
    service
      .get(url, options)
      .then(response => {
        if (handler != null) {
          handler(response)
          resolve(true)
        }
        if (response.status === 1) {
          // if (tools.isEmpty(response.result)) {
          //   resolve(true)
          // } else {
          //   resolve(response.result)
          // }
        } else {
          Message({
            message: response.message || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
          return Promise.reject(new Error(response.message || 'Error'))
        }
      })
      .catch(e => {
      })
  })
}

http.post = (params) => {
  return new Promise((resolve, reject) => {
    const { url, data, handler, permissionKey } = params
    var headersPermission = null
    if (permissionKey != null) {
      headersPermission = { headers: { 'PermissionKey': permissionKey }}
    }
    service
      .post(url, data, headersPermission)
      .then(response => {
        if (handler != null) {
          handler(response)
          resolve(true)
        }
        if (response.status === 1 || response.status === 0) {
          // if (tools.isEmpty(response.result)) {
          //   resolve(true)
          // } else {
          //   resolve(response.result)
          // }
          resolve(response.result)
        }else if(response.status === 3){
          resolve(response)
        } else if(response.status === 5){ // 登录错误
          resolve(response)
        }else {
          Message({
            message: response.message || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
          if(url.indexOf('CheckMobileCode') > -1) resolve(response)
          // return Promise.reject(new Error(response.message || 'Error'))
        }
      })
      .catch(e => {
        reject(e)
      })
  })
}
export default http
